import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SxSLayerView" */ './lazyIndex');
});
var SxSLayerView = createLazyComponent(lazyModule, function (m) { return m.SxSLayerView; });
export { SxSLayerView };
//# sourceMappingURL=index.js.map